import { render, staticRenderFns } from "./UsersGoalsForm.vue?vue&type=template&id=158e92bf&scoped=true&"
import script from "./UsersGoalsForm.vue?vue&type=script&lang=js&"
export * from "./UsersGoalsForm.vue?vue&type=script&lang=js&"
import style0 from "./UsersGoalsForm.vue?vue&type=style&index=0&id=158e92bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e92bf",
  null
  
)

export default component.exports